<template>
  <div class="view-wrapper">
    <v-card class="elevation-1 rounded-0" color="grey lighten-4">
      <v-card-text>
        <div class="text-caption grey--text text--darken-1">Sugestões baseadas em:</div>
        <div class="text-h6 font-weight-bold primary--text">
          {{ produto.nome || 'Produto Selecionado' }}
        </div>
        <div class="d-flex justify-space-between align-center">
          <span class="text-caption">Grupo ID: {{ produto.idgrupo || '...' }}</span>
          <v-chip x-small color="primary" outlined>
            {{ produtosSugeridos.length }} itens encontrados
          </v-chip>
        </div>
      </v-card-text>
      <v-divider></v-divider>
    </v-card>

    <div class="content-container">
      <div v-if="loading" class="text-center pa-8">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
        <p class="mt-4 mb-0 caption">Buscando itens relacionados no banco local...</p>
      </div>

      <div v-else-if="produtosSugeridos.length === 0" class="text-center pa-8 mt-4">
        <v-icon size="48" color="grey lighten-2">mdi-lightbulb-off-outline</v-icon>
        <p class="mt-2 grey--text">Nenhuma sugestão encontrada para este grupo.</p>
      </div>

      <simplebar
        v-else
        data-simplebar
        :autoHide="false"
        class="lista-resultados-container"
      >
        <v-list two-line class="py-0">
          <template v-for="(item, index) in produtosSugeridos">
            <v-list-item :key="item.codigo" @click="adicionarAoPedido(item)">
              
              <v-list-item-avatar tile size="50" class="my-0 ml-2 mr-1">
                
                <v-row v-if="item.imagemCarregando" class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular indeterminate color="primary" size="20"></v-progress-circular>
                </v-row>

                <v-img
                  v-else-if="item.imagemUrl" 
                  :src="item.imagemUrl" 
                  contain 
                  background-color="grey lighten-4"
                >
                </v-img>

                <v-img
                  v-else
                  contain 
                  background-color="grey lighten-4"
                >
                  <v-row class="fill-height ma-0" align="center" justify="center">
                      <v-icon color="grey lighten-1">mdi-package-variant</v-icon>
                  </v-row>
                </v-img>

              </v-list-item-avatar>
              
              <v-list-item-content>
                <v-list-item-title class="font-weight-medium text-body-2">
                  {{ item.codigo }} - {{ item.nome }}
                </v-list-item-title>
                <v-list-item-subtitle class="mt-1">
                  <span class="green--text font-weight-bold ml-1">{{ formatarMoeda(item.preco) }}</span>
                </v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-action>
                <v-btn icon color="primary">
                  <v-icon>mdi-cart-plus</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
            <v-divider v-if="index < produtosSugeridos.length - 1" :key="`divider-${index}`"></v-divider>
          </template>
        </v-list>
      </simplebar>
    </div>
  </div>
</template>

<script>
import simplebar from 'simplebar-vue';
import 'simplebar-vue/dist/simplebar.min.css';
import db from '@/plugins/dexie';
export default {
  name: 'ViewPesquisaProdutoSugerido',

  components: {
    simplebar,
  },

  props: {
    produto: {
      type: Object,
      default: () => ({
        nome: '',
        codigo: '',
        idgrupo: null
      })
    }
  },

  data() {
    return {
      loading: false,
      produtosSugeridos: [], 
      imagemCache: {}, 
    };
  },

  watch: {
    produto: {
      immediate: true,
      deep: true,
      handler(novoProduto) {
        if (novoProduto && novoProduto.idgrupo) {
          this.carregarSugestoes(novoProduto.idgrupo);
        }
      }
    }
  },

  methods: {

    async carregarSugestoes(idgrupo) {
  if (!idgrupo) return;

  this.loading = true;
  this.produtosSugeridos = [];
  
  try {
    if (!db.produtosugerido) {
      console.warn('Tabela produtoSugerido não existe no Dexie.');
      return;
    }
    const sugestoes = await db.produtosugerido
      .where('idgrupo')
      .equals(Number(idgrupo)) 
      .toArray();

    if (!sugestoes.length) return;
    const idsGruposAlvo = sugestoes
        .map(s => s.idprodutosugerido || s.idprodutosugerido)
        .filter(id => id);

    if (idsGruposAlvo.length === 0) return;

    const produtosReais = await db.produto
      .where('idgrupo')
      .anyOf(idsGruposAlvo)
      .toArray();

    this.produtosSugeridos = produtosReais.map(p => {
      const idCortamanhofinal = p.idcortamanhofinal || p.idCortamanhofinal || p.IdCortamanhofinal;
      const idProduto = p.idproduto || p.idProduto || p.IdProduto;
      return {
        idcortamanhofinal: idCortamanhofinal,
        idCortamanhofinal: idCortamanhofinal,
        idproduto: idProduto,
        idProduto: idProduto,
        codigo: p.codigointerno || p.codigoInterno || p.CodigoInterno,
        nome: p.descricao || p.Descricao,
        preco: p.preco || p.Preco,
        imagemUrl: this.imagemCache[idCortamanhofinal] || null,
        imagemCarregando: false,
        temImagem: p.temImagem || p.temimagem || p.TemImagem, 
      };
    });

    this.produtosSugeridos.forEach(this.carregarImagemItem);

  } catch (error) {
    console.error("Erro ao carregar sugestões:", error);
  } finally {
    this.loading = false;
  }
},

    async carregarImagemItem(item) {
      if (!item.temImagem || item.temImagem === 'N') return;
      
      const idChave = item.idcortamanhofinal || item.idCortamanhofinal;
      if (this.imagemCache[idChave]) {
          this.$set(item, 'imagemUrl', this.imagemCache[idChave]);
          return;
      }

      if (item.imagemUrl || item.imagemCarregando) return;

      this.$set(item, 'imagemCarregando', true);

      try {
        if (db.imagem) {
          const cache = await db.imagem.where('idcortamanhofinal').equals(idChave).first();
          if (cache && cache.imgBlob1) {
            const urlCache = URL.createObjectURL(cache.imgBlob1);
            this.imagemCache[idChave] = urlCache;
            
            this.$set(item, 'imagemUrl', urlCache);
            this.$set(item, 'imagemCarregando', false);
            return; 
          }
        }
      } catch (e) { console.warn(e); }

      try {
        const blob = await this.fetchImagem({ 
            id: idChave, 
            indice: 1 
        });
        
        if (blob && blob.size > 0) {
          let blobParaSalvar = blob;
          if (!(blob instanceof Blob)) {
            blobParaSalvar = new Blob([blob], { type: 'image/jpeg' });
          }

          const urlCriada = URL.createObjectURL(blobParaSalvar);
          
          this.imagemCache[idChave] = urlCriada;
          this.$set(item, 'imagemUrl', urlCriada);
          
          if (db.imagem) {
            const cache = await db.imagem.where('idcortamanhofinal').equals(idChave).first();
            if (cache) {
              await db.imagem.where('idcortamanhofinal').equals(idChave).modify({
                imgBlob1: blobParaSalvar,
                dataDownloadImagem: new Date()
              });
            } else {
              await db.imagem.add({
                idproduto: item.idproduto || item.idProduto || idChave,
                idcortamanhofinal: idChave,
                imgBlob1: blobParaSalvar,
                dataDownloadImagem: new Date()
              });
            }
          }
        } else {
          this.$set(item, 'imagemUrl', null); 
        }

      } catch (error) {
        this.$set(item, 'imagemUrl', null);
      } finally {
        this.$set(item, 'imagemCarregando', false);
      }
    },

    adicionarAoPedido(item) {
      this.$router.push({
        path: '/cadastro-pedido-item',
        query: {
          idProduto: item.idCortamanhofinal,
          produtoCodigo: item.codigo, 
        },
      });
    },

    formatarMoeda(valor) {
      if (!valor) return '0,00';
      return valor.toLocaleString('pt-BR', { 
        minimumFractionDigits: 2, 
        maximumFractionDigits: 2 
      });
    },
  }
};
</script>

<style scoped>
.view-wrapper {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 56px);
  background-color: white;
}

.content-container {
  flex-grow: 1;
  overflow: hidden;
  position: relative;
}

.lista-resultados-container {
  height: 100%;
  overflow-y: auto;
}

/* Ajuste visual para o scrollbar ficar bonito */
.lista-resultados-container ::v-deep .simplebar-scrollbar::before {
  background: rgba(76, 111, 175, 0.4) !important;
}
</style>